__turbopack_context__.v({
  "searchPlace": "search-place-select-module-scss-module__2C_cBG__searchPlace",
  "searchPlace__isMainPage": "search-place-select-module-scss-module__2C_cBG__searchPlace__isMainPage",
  "searchPlace__square": "search-place-select-module-scss-module__2C_cBG__searchPlace__square",
  "searchPlace_clearIcon": "search-place-select-module-scss-module__2C_cBG__searchPlace_clearIcon",
  "searchPlace_clearIcon__single": "search-place-select-module-scss-module__2C_cBG__searchPlace_clearIcon__single",
  "searchPlace_dropdown": "search-place-select-module-scss-module__2C_cBG__searchPlace_dropdown",
  "searchPlace_forwardIcon": "search-place-select-module-scss-module__2C_cBG__searchPlace_forwardIcon",
  "searchPlace_geoIcon": "search-place-select-module-scss-module__2C_cBG__searchPlace_geoIcon",
  "searchPlace_input": "search-place-select-module-scss-module__2C_cBG__searchPlace_input",
  "searchPlace_select": "search-place-select-module-scss-module__2C_cBG__searchPlace_select",
  "search_place_wrapper": "search-place-select-module-scss-module__2C_cBG__search_place_wrapper",
});
